import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectAccessToken } from '../Redux/slices/authState';

export default function PreventedRoute({ children }) {
  const token =  useSelector(selectAccessToken) 
  return !token? children : <Navigate to={'/'} />;
}
